import { InputAdornment, TextField } from '@mui/material';
import { TextFieldProps } from '@mui/material/TextField/TextField';
import React from 'react';

type PropsType = TextFieldProps & {
  currency: string;
};

export const CurrencyField = (props: PropsType) => {
  const { InputProps, currency, value, ...restProps } = props;

  const fieldProps: TextFieldProps = {
    InputProps: {
      inputMode: 'decimal',
      inputProps: {
        style: {
          textAlign: 'right',
        },
      },
      endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
      ...InputProps,
    },
    value: typeof value === 'number' ? value.toFixed(2) : value,
    ...restProps,
  };

  return <TextField {...fieldProps} />;
};
